"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailabilityStatus = exports.getOwnershipStatus = exports.OWNERSHIP_STATUSES = exports.canPlayFullOrPreview = exports.getAvailableVideoType = exports.AVAILABLE_VIDEO_TYPES = exports.getFullAccessActionName = exports.FULL_ACCESS_ACTION_NAMES = exports.canAccessFullVideo = exports.isDownloadAllowed = exports.isAccessAllowed = exports.isVideoExist = exports.isForMemberOnly = void 0;
var lodash_1 = require("lodash");
var pricing_1 = require("../../common/ui-selectors/video/pricing");
var pricing_2 = require("../../common/ui-selectors/channel/pricing");
var preview_types_1 = require("@wix/wix-vod-constants/dist/common/preview-types");
var preview_1 = require("../../common/ui-selectors/video/preview");
var channel_access_1 = require("./channel-access");
var live_1 = require("../../common/ui-selectors/video/live");
var video_origin_1 = require("../../common/ui-selectors/video/video-origin");
var deal_info_helpers_1 = require("../../common/utils/deal-info-helpers");
function isLoggedIn(currentSiteUser) {
    return !(0, lodash_1.isEmpty)(currentSiteUser);
}
function isForMemberOnly(video) {
    return Boolean(video.memberOnly);
}
exports.isForMemberOnly = isForMemberOnly;
function isVideoExist(video) {
    return !(0, live_1.isScheduledLive)(video) && !(0, live_1.isPendingLiveStream)(video);
}
exports.isVideoExist = isVideoExist;
function isAccessAllowed(channel, video, currentSiteUser) {
    if ((0, pricing_1.isFree)(video)) {
        if ((0, pricing_2.isSubscriptionEnabled)(channel) && !(0, video_origin_1.isExternalVideo)(video)) {
            return (0, pricing_2.isSubscribedTo)(channel);
        }
        else if ((0, pricing_2.isPricingPlanEnabled)(channel) &&
            !(0, video_origin_1.isExternalVideo)(video)) {
            return (0, pricing_2.hasAccessToChannelByPricingPlan)(channel);
        }
        else {
            return !isForMemberOnly(video) || isLoggedIn(currentSiteUser);
        }
    }
    return ((0, pricing_1.isRented)(video) ||
        (0, pricing_1.isBought)(video) ||
        (0, channel_access_1.canAccessChannelWithSubscription)(channel) ||
        (0, channel_access_1.canAccessChannelByPricingPlan)(channel));
    /* eslint-enable */
}
exports.isAccessAllowed = isAccessAllowed;
function isDownloadAllowed(channel, video, currentSiteUser) {
    if (isVideoExist(video)) {
        if ((0, pricing_1.isFree)(video)) {
            return !isForMemberOnly(video) || isLoggedIn(currentSiteUser);
        }
        else {
            return (0, pricing_1.isBought)(video) || (0, channel_access_1.canAccessChannelWithSubscription)(channel);
        }
    }
    return false;
}
exports.isDownloadAllowed = isDownloadAllowed;
function canAccessFullVideo(channel, video, currentSiteUser) {
    return (isVideoExist(video) && isAccessAllowed(channel, video, currentSiteUser));
}
exports.canAccessFullVideo = canAccessFullVideo;
// What user need to do to get access to full video
exports.FULL_ACCESS_ACTION_NAMES = {
    SIGN_IN: 'needs-sign-in',
    SUBSCRIBE: 'needs-subscription',
    BUY: 'need-to-buy',
    RENT: 'need-to-rent',
    BUY_OR_RENT: 'need-to-buy-or-rent',
    PRICING_PLAN: 'pricing-plan-enabled',
};
function getFullAccessActionName(channel, video, currentSiteUser) {
    if (canAccessFullVideo(channel, video, currentSiteUser)) {
        return null;
    }
    if (isAccessAllowed(channel, video, currentSiteUser) &&
        ((0, live_1.isScheduledLive)(video) || (0, live_1.isPendingLiveStream)(video))) {
        return null;
    }
    if ((0, pricing_2.isPricingPlanEnabled)(channel)) {
        var pricingPlanInfo = (0, deal_info_helpers_1.getPricingPlanInfo)(channel.dealInfo);
        // channel.subscriptionOnly shows if purchase or rent of single videos in a channel is disabled.
        // this value common for subscription and pricing plans.
        // channel.subscriptionOnly - in V2, pricingPlanInfo?.required - in V3
        if ((0, pricing_1.isFree)(video) ||
            channel.subscriptionOnly ||
            (pricingPlanInfo === null || pricingPlanInfo === void 0 ? void 0 : pricingPlanInfo.required)) {
            return exports.FULL_ACCESS_ACTION_NAMES.PRICING_PLAN;
        }
    }
    if ((0, pricing_1.isFree)(video) && (0, pricing_2.isSubscriptionEnabled)(channel)) {
        return (0, pricing_2.isSubscribedTo)(channel) ? null : exports.FULL_ACCESS_ACTION_NAMES.SUBSCRIBE;
    }
    if ((0, pricing_1.isFree)(video) && isForMemberOnly(video)) {
        return exports.FULL_ACCESS_ACTION_NAMES.SIGN_IN;
    }
    if ((0, pricing_2.isSubscriptionEnabled)(channel)) {
        var subscriptionInfo = (0, deal_info_helpers_1.getSubscriptionPriceInfo)(channel.dealInfo);
        // channel.subscriptionOnly shows if purchase or rent of single videos in a channel is disabled.
        // this value common for subscription and pricing plans.
        // channel.subscriptionOnly - in V2, subscriptionInfo?.required - in V3
        if (channel.subscriptionOnly || (subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.required)) {
            return exports.FULL_ACCESS_ACTION_NAMES.SUBSCRIBE;
        }
    }
    if ((0, pricing_1.isRentEnabled)(video) && (0, pricing_1.isSaleEnabled)(video)) {
        return exports.FULL_ACCESS_ACTION_NAMES.BUY_OR_RENT;
    }
    if ((0, pricing_1.isRentEnabled)(video)) {
        return exports.FULL_ACCESS_ACTION_NAMES.RENT;
    }
    if ((0, pricing_1.isSaleEnabled)(video)) {
        return exports.FULL_ACCESS_ACTION_NAMES.BUY;
    }
}
exports.getFullAccessActionName = getFullAccessActionName;
var AVAILABLE_VIDEO_TYPES;
(function (AVAILABLE_VIDEO_TYPES) {
    AVAILABLE_VIDEO_TYPES["FULL"] = "full-video";
    AVAILABLE_VIDEO_TYPES["TRAILER"] = "trailer";
    AVAILABLE_VIDEO_TYPES["FIRST_20_SEC"] = "preview";
    AVAILABLE_VIDEO_TYPES["LIVE_STREAMING"] = "live-streaming";
})(AVAILABLE_VIDEO_TYPES = exports.AVAILABLE_VIDEO_TYPES || (exports.AVAILABLE_VIDEO_TYPES = {}));
function getAvailableVideoType(channel, video, currentSiteUser) {
    if (canAccessFullVideo(channel, video, currentSiteUser)) {
        return (0, live_1.isReadyLiveStream)(video)
            ? AVAILABLE_VIDEO_TYPES.LIVE_STREAMING
            : AVAILABLE_VIDEO_TYPES.FULL;
    }
    if ((0, pricing_1.isFree)(video) && isForMemberOnly(video)) {
        return;
    }
    var previewType = (0, preview_1.getPreviewType)(video);
    if ((0, preview_1.hasTrailer)(video) && previewType === preview_types_1.PREVIEW_TYPES.TRAILER) {
        return AVAILABLE_VIDEO_TYPES.TRAILER;
    }
    if (previewType === preview_types_1.PREVIEW_TYPES.FIRST_20_SEC) {
        return AVAILABLE_VIDEO_TYPES.FIRST_20_SEC;
    }
}
exports.getAvailableVideoType = getAvailableVideoType;
function canPlayFullOrPreview(channel, video, currentSiteUser) {
    return Boolean(getAvailableVideoType(channel, video, currentSiteUser));
}
exports.canPlayFullOrPreview = canPlayFullOrPreview;
var OWNERSHIP_STATUSES;
(function (OWNERSHIP_STATUSES) {
    OWNERSHIP_STATUSES["YOU_BOUGHT_THIS"] = "user-bought-video";
    OWNERSHIP_STATUSES["YOU_RENTED_THIS"] = "user-rented-video";
})(OWNERSHIP_STATUSES = exports.OWNERSHIP_STATUSES || (exports.OWNERSHIP_STATUSES = {}));
var getOwnershipStatus = function (video) {
    if ((0, pricing_1.isBought)(video)) {
        return OWNERSHIP_STATUSES.YOU_BOUGHT_THIS;
    }
    if ((0, pricing_1.isRented)(video)) {
        return OWNERSHIP_STATUSES.YOU_RENTED_THIS;
    }
};
exports.getOwnershipStatus = getOwnershipStatus;
var getAvailabilityStatus = function (_a) {
    var channelData = _a.channelData, videoItem = _a.videoItem, currentSiteUser = _a.currentSiteUser;
    return ((0, exports.getOwnershipStatus)(videoItem) ||
        getFullAccessActionName(channelData, videoItem, currentSiteUser));
};
exports.getAvailabilityStatus = getAvailabilityStatus;
//# sourceMappingURL=video-access.js.map